module.exports = __webpack_public_path__ + "static/jmsdermyy-f1338ae803828575f50e480357b390d7.jpg";